import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import NotificationsContext from '../../contexts/NotificationsContext';

import Menu from '../Menu/Menu';
import Logo from '../../assets/images/static/Logo.svg';
import { MenuIcon } from '../../components/icons';

const HeaderMobile = ({ language }) => {
  const { t } = useTranslation();

  const { setIsPanelOpened } = useContext(NotificationsContext);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMenuClick = () => {
    setIsMenuOpen(!isMenuOpen);
    setIsPanelOpened(false);
  };

  return (
    <>
      <header className='headerMobile'>
        <div className='headerMobile__content'>
          <div className='headerMobile__content__notification'>
            <div>
              {/* <NotificationIcon
                onClick={() => {
                  setIsPanelOpened(!isPanelOpened);
                  setIsMenuOpen(false);
                }}
                notifications={notifications}
                width="23px"
              /> */}
            </div>
          </div>

          <Link
            to={`${language}${t('routes.home')}`}
            className='headerMobile__content__logo'
          >
            <img loading='auto' src={Logo} alt='Tower Partners' />
          </Link>

          <div className='headerMobile__content__menu'>
            <MenuIcon
              setIsMenuOpen={setIsMenuOpen}
              isMenuOpen={isMenuOpen}
              handleMenuClick={handleMenuClick}
            />
          </div>
        </div>
      </header>

      <Menu isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
    </>
  );
};

export default HeaderMobile;
